import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
// ESTILOS
import styles from '../../../estilos/callback.module.css';

function CallbackDidit() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Fuente principal: el query param que el propio backend le pidió a Didit
  // que devolviera en el callback (sobrevive aunque el navegador haya
  // recargado la pestaña durante el flujo externo). sessionStorage queda
  // solo como respaldo por si la URL no trae el dato por algún motivo.
  const [volverA] = useState(() => {
    let guardado = null;

    try {
      const desdeUrl = searchParams.get("returnTo");
      if (desdeUrl) guardado = desdeUrl;
    }
    catch (e) { /* noop */ }

    try {
      if (!guardado) guardado = sessionStorage.getItem("hpm_volverA");
      sessionStorage.removeItem("hpm_volverA");
    }
    catch (e) { /* noop */ }

    return guardado || null;
  });

  function continuar() {
    if (volverA) navigate(volverA, { replace: true });
    else window.location.href = "/";
  }

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <img className="mb-3" src="/imagenes/marca/zervicyazulhorizontal.png" alt="Zervicy" style={{ width: "160px", marginBottom: "20px" }} />

        <h2 className={styles.title}>¡Gracias! 🙌</h2>
        <p className={styles.text}>
          Hemos recibido tu solicitud y estamos revisando tu verificación.
        </p>
        <p className={styles.text}>
          {volverA
            ? "Te avisaremos apenas tengamos una respuesta. Mientras tanto, puedes volver a donde estabas."
            : "Por favor, vuelve a la página anterior. En breve tendrás una respuesta sobre tu verificación."}
        </p>
        <button
          className="btn btn-primary mt-3"
          onClick={continuar}
        >
          {volverA ? "Volver a donde estaba" : "Volver al home"}
        </button>
      </div>
    </div>
  );
}


export default CallbackDidit;
